import { MenuItem, TextField, useMediaQuery } from '@mui/material';
import { breakpoints } from '../../constants';
import { TFormValues } from '../../types';
import { Row } from '../Row';
import { useTranslation } from 'react-i18next';

interface IProps {
    setFieldValue(field: keyof TFormValues, value: string): void;
    getFieldError: (fieldName: keyof TFormValues) => string | undefined;
    formValues: TFormValues;
}

export const NameSection = ({
    formValues,
    getFieldError,
    setFieldValue,
}: IProps) => {
    const mediumBreakpoint = useMediaQuery(`(${breakpoints.mediumMin})`);
    const { t } = useTranslation();

    return (
        <>
            <TextField
                select
                error={!!getFieldError('salutation')}
                helperText={getFieldError('salutation')}
                id="salutation"
                label={t('salutation')}
                name="salutation"
                sx={{ maxWidth: '140px' }}
                value={formValues.salutation}
                onChange={(e) => setFieldValue('salutation', e.target.value)}
            >
                <MenuItem value={t('mr')}>{t('mr')}</MenuItem>
                <MenuItem value={t('mrs')}>{t('mrs')}</MenuItem>
            </TextField>
            <Row>
                <TextField
                    error={!!getFieldError('firstName')}
                    helperText={getFieldError('firstName')}
                    id="firstName"
                    label={t('firstName') + ' *'}
                    value={formValues.firstName}
                    onChange={(e) => setFieldValue('firstName', e.target.value)}
                />
                <TextField
                    error={!!getFieldError('lastNamePrefix')}
                    helperText={getFieldError('lastNamePrefix')}
                    id="lastNamePrefix"
                    label={t('lastNamePrefix')}
                    sx={{ margin: `${mediumBreakpoint && '0 10px'}` }}
                    value={formValues.lastNamePrefix}
                    onChange={(e) =>
                        setFieldValue('lastNamePrefix', e.target.value)
                    }
                />
                <TextField
                    error={!!getFieldError('firstName')}
                    helperText={getFieldError('firstName')}
                    id="lastName"
                    label={t('lastName') + ' *'}
                    value={formValues.lastName}
                    onChange={(e) => setFieldValue('lastName', e.target.value)}
                />
            </Row>
        </>
    );
};
